<template>
  <div class="mlx-signup-page" :style="{ '--mlx-accent': themeColorTheme2 }">
    <div class="mlx-signup-card">
      <div class="mlx-signup-head">
        <h1 class="mlx-signup-title">Create your profile</h1>
        <p class="mlx-signup-sub">Tell us a bit about you to get started</p>
      </div>

      <form role="form" @submit.prevent>
        <div class="mlx-field">
          <label class="mlx-label" for="name">NAME</label>
          <div class="mlx-input-box">
            <input
              id="name"
              class="mlx-input"
              type="text"
              name="name"
              placeholder="Your name"
              v-model="form.name"
            />
          </div>
        </div>

        <div class="mlx-field">
          <label class="mlx-label" for="email">EMAIL</label>
          <div class="mlx-input-box">
            <input
              id="email"
              class="mlx-input"
              type="email"
              name="email"
              placeholder="you@example.com"
              v-model="form.email"
            />
          </div>
        </div>

        <div class="mlx-field">
          <label class="mlx-label" for="dob">DATE OF BIRTH</label>
          <div class="mlx-input-box">
            <input
              id="dob"
              class="mlx-input"
              type="date"
              name="dob"
              v-model="form.dob"
            />
          </div>
        </div>

        <label class="mlx-consent" for="agree">
          <input
            id="agree"
            class="mlx-consent-box"
            type="checkbox"
            v-model="form.agree"
          />
          <span>
            I agree to the
            <router-link :to="{ name: 'SignIn' }" class="mlx-consent-link"
              >Terms and Conditions</router-link
            >
          </span>
        </label>

        <button
          type="submit"
          class="mlx-btn-primary"
          :style="`background: ${buttonColorTheme2};`"
        >
          Sign Up
        </button>
      </form>

      <p class="mlx-signup-footer">
        Already have an account?
        <router-link :to="{ name: 'SignIn' }" class="mlx-signup-footer-link"
          >Sign In</router-link
        >
      </p>
    </div>
  </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";

export default {
  name: "sign-up",
  data() {
    return {
      form: {
        name: "",
        email: "",
        dob: "",
        agree: true,
      },
    };
  },
  computed: {
    themeColorTheme2() {
      return this.$store.state.mainThemeColorTheme2
        ? this.$store.state.mainThemeColorTheme2
        : this.$store.state.color;
    },
    buttonColorTheme2() {
      return this.$store.state.primaryButtonColorTheme2
        ? this.$store.state.primaryButtonColorTheme2
        : this.themeColorTheme2;
    },
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
  },
};
</script>

<style scoped>
/* MTH008 — theme2 reskin of the sign-up / profile form */
.mlx-signup-page {
  position: relative;
  z-index: 3;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: #fff;
  padding: 32px 20px 48px;
}
.mlx-signup-card {
  width: 100%;
  max-width: 440px;
}
.mlx-signup-head {
  text-align: center;
  margin-bottom: 32px;
}
.mlx-signup-title {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--mlx-accent);
  margin: 8px 0 8px;
}
.mlx-signup-sub {
  font-size: 14px;
  line-height: 1.5;
  color: #857372;
  margin: 0;
}
.mlx-field {
  margin-bottom: 18px;
}
.mlx-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mlx-accent);
  margin: 0 0 8px 4px;
}
.mlx-input-box {
  display: flex;
  align-items: center;
  border: 1px solid rgba(215, 194, 192, 0.6);
  border-radius: 16px;
  background: #fff;
  transition: border-color 0.2s ease;
}
.mlx-input-box:focus-within {
  border-color: var(--mlx-accent);
}
.mlx-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  font-size: 16px;
  font-weight: 500;
  color: #201a1a;
  padding: 14px 16px;
}
.mlx-input::placeholder {
  color: rgba(133, 115, 114, 0.5);
}
.mlx-consent {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  line-height: 1.5;
  color: #857372;
  margin: 8px 4px 0;
  cursor: pointer;
}
.mlx-consent-box {
  width: 20px;
  height: 20px;
  margin-top: 1px;
  accent-color: var(--mlx-accent);
  cursor: pointer;
  flex-shrink: 0;
}
.mlx-consent-link {
  color: var(--mlx-accent);
  font-weight: 700;
  text-decoration: none;
}
.mlx-btn-primary {
  width: 100%;
  border: none;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  padding: 16px;
  border-radius: 16px;
  margin-top: 24px;
  cursor: pointer;
  transition: transform 0.1s ease, opacity 0.2s ease;
}
.mlx-btn-primary:active {
  transform: scale(0.98);
}
.mlx-signup-footer {
  text-align: center;
  font-size: 13px;
  color: #857372;
  margin: 24px 0 0;
}
.mlx-signup-footer-link {
  color: var(--mlx-accent);
  font-weight: 700;
  text-decoration: none;
}
</style>
